var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160693",
    "data-name": "Group 160693",
    transform: "translate(-463.5 -263.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160612",
    "data-name": "Group 160612",
    transform: "translate(464 264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1149",
    "data-name": "Rectangle 1149",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "#ffecd4",
    stroke: "#787f88",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    width: 16.081,
    height: 16.61,
    rx: 2,
    transform: "translate(0.895 0.676)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266",
    transform: "translate(4.682 3.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M10.314,6.06l.464-.936a.287.287,0,0,1,.513,0L12.414,7.4a.277.277,0,0,0,.212.155l2.508.366a.285.285,0,0,1,.155.489l-1.816,1.767a.292.292,0,0,0-.081.252l.432,2.492a.284.284,0,0,1-.415.3l-2.239-1.181a.311.311,0,0,0-.269,0L8.661,13.217a.284.284,0,0,1-.415-.3l.432-2.492a.292.292,0,0,0-.081-.252L6.78,8.405",
    transform: "translate(-6.78 -4.965)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 0.309,
    x2: 0.155,
    transform: "translate(3.298 1.258)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 11.082,
    height: 1.213,
    rx: 0.607,
    transform: "translate(3.387 13.809)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 0.464,
    cy: 0.464,
    r: 0.464,
    transform: "translate(6.293 5.496)",
    fill: "#787f88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesWhiteIcon);
export default __webpack_public_path__ + "static/media/features-white-icon.36b98fb3a5145837062b38b4468f1395.svg";
export { ForwardRef as ReactComponent };